/* Block - Video Carousel.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from './block-video-carousel.scss';
import rsVideoModule from '../../js/component/_video-module';

rsVideoModule.initCarousel();
